import React from 'react';
import { Panel, Placeholder } from 'rsuite'

export class CountryNewsList extends React.Component {

    truncate = (source, size) => {
        return source.length > size ? source.slice(0, size - 1) + "…" : source;
    }


    render() {
        const { Paragraph } = Placeholder;
        return (
            this.props.articlesLoaded ?
                <div className="country-news">
                    {this.props.news.map((article,index) => {
                        return (
                            <a key={index} href={article.link} className="news-link" target="_blank">
                            <Panel bordered>

                                {article.enclosure !== undefined ?
                                    <div className="news-img" style={{ backgroundImage: 'url(' + article.enclosure.url + ')' }}></div>
                                    : null
                                }
                                <div className={article.enclosure !== undefined ? 'news-text' : 'news-text-no-img'}>
                                    <div className="news-title">{article.enclosure !== undefined ? this.truncate(article.title, 90) : article.title}</div>
                                    <div className='news-source'>{this.truncate(this.props.newsSource, 40)}</div>
                                </div>
                            </Panel>
                            </a>)
                    })}
                </div>

                :

                <div className="country-news-placeholder">
                        <Panel bordered>
                            <Paragraph rows={3} graph="image" active />
                        </Panel>
                        <Panel bordered>
                            <Paragraph rows={3} graph="image" active />
                        </Panel>
                        <Panel bordered>
                            <Paragraph rows={3} graph="image" active />
                        </Panel>
                        <Panel bordered>
                            <Paragraph rows={3} graph="image" active />
                        </Panel>
                </div>
        )
    }
}